import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import thunk from 'redux-thunk';
import { configureStore } from '@reduxjs/toolkit'

import articleListingReducer from './articleListingReducer.mjs';
import ArticleList from './ArticleList';


let store = configureStore({
    reducer: articleListingReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(thunk),
    devTools: window?.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__({
        name: "Article Listing"
    })    
},
    
);

const rootContainer = document.getElementById('article-listing-app');

if (rootContainer) {
    
    const root = createRoot(rootContainer);

    root.render(
        <div>
            <Provider store={store}>
                <ArticleList {...(rootContainer.dataset) } sectionid="ajankohtaiset"/>
            </Provider>
        </div>
    );
}
